import MUITableCell from '@mui/material/TableCell'
import type { CSSObject } from '../../theme/themeTypes'
import { styled } from '../../../utils/styled'
import { type TableFooterCellProps } from './types'

export const StyleTableFooterCell = styled(MUITableCell)(
  (): CSSObject => ({
    border: 'none',
    padding: 0
  })
) as React.ComponentType<TableFooterCellProps>
